import { Component, Input, OnInit, ElementRef, ViewChildren, ViewChild, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { SearchOption } from 'src/app/components/util/search/searchOption';
import { Dpto } from 'src/app/models/obs/dpto';
import { Sector } from 'src/app/models/obs/sector';
import { DptoService } from 'src/app/services/obs/dpto.service';
import { SectorService } from 'src/app/services/obs/sector.service';
import { Tier3Service } from 'src/app/services/obs/tier3.service';
@Component({
  selector: 'app-search-contextual',
  templateUrl: './search-contextual.component.html',
  styleUrl: './search-contextual.component.scss'
})
export class SearchContextualComponent implements OnInit, AfterViewChecked {
  @Input() idEvenType: number;
  @ViewChildren('modalButton') modalButton: ElementRef;
  @ViewChild('searchInput', { static: false }) searchInput: ElementRef;
  showModal = false;
  sectorList: Sector[] = [];
  dptoList: Dpto[] = [];

  searchResults: SearchOption[] = [];

  query: string = '';
  idsector: number = 0;
  pages: number = 1;
  /* recibimos el termino a sombrear */
  highlights = '';
  placeholder: string = "";

  constructor(
    private cdr: ChangeDetectorRef,
    private dptoS: DptoService,
    private sectorS: SectorService,
    private t3S: Tier3Service
  ) { }

  ngOnInit() {
    this.getPlaceholder();
    this.getAllSector();
    this.getAllDptos();
  }

  ngAfterViewChecked() {
    if (this.searchInput) {
      this.searchInput.nativeElement.focus();
      this.cdr.detectChanges();
    }
  }

  getAllSector() {
    this.sectorS.getAll().subscribe({
      next: res => {
        this.sectorList = res['data'];
      },
      error: err => {
        console.log("Sector");
      }
    })
  }

  getAllDptos() {
    this.dptoS.getAll().subscribe({
      next: res => {
        this.dptoList = res['data'];
      },
      error: err => {
        console.error('departamentos', err);
      }
    })
  }

  activateModal() {
    this.search();
    const firstElement = this.modalButton['first'];
    if (firstElement && firstElement.nativeElement) {
      firstElement.nativeElement.click();
    }
  }

  search() {
    /* this.idsector = this.searchSectorRef.nativeElement.value; */
    const cleanedQuery = this.cleanAndValidateQuery(this.query);

    if (this.idsector > 0) {
      this.searchtree(cleanedQuery, this.idEvenType, this.idsector)
    } else {
      this.searchtwo(cleanedQuery, this.idEvenType)
    }
    this.highlights = cleanedQuery;
  }

  searchtwo(q: string, idEvenType: number) {
    this.t3S.getRelatedT3By2Params(q, idEvenType).subscribe({
      next: res => {
        this.searchResults = res;
        this.pages = 1;
      },
      error: err => {
        console.error('Error en la búsqueda', err);
      }
    });
  }

  searchtree(q: string, idEvenType: number, idsector: number) {
    this.t3S.getRelatedT3By3Params(q, idEvenType, idsector).subscribe({
      next: res => {
        this.searchResults = res;
      },
      error: err => {
        console.error('Error en la búsqueda', err);
      }
    });
  }

  getDptoName(idpto: string): string {
    const departamento = this.dptoList.find(dpto => dpto.iddpto === idpto);
    if (departamento) {
      if (departamento.dpto === 'Lima Metropolitana' || departamento.dpto === 'Callao') {
        return `Provincia: ${departamento.dpto}`;
      } else {
        return `Departamento: ${departamento.dpto}`;
      }
    }
    return '';
  }

  getSectorName(idsector: number): string {
    const sector = this.sectorList.find(sector => sector.id === idsector);
    return sector ? sector.longname : '';
  }

  closeModal() {
    this.showModal = false;
  }

  getPlaceholder() {
    switch (Number(this.idEvenType)) {
      case 1:
        this.placeholder = "Buscar en tendencias";
        break;
      case 2:
        this.placeholder = "Buscar en riesgos";
        break;
      case 3:
        this.placeholder = "Buscar en oportunidades";
        break;
      default:
        this.placeholder = "Buscar en escenarios";
        break;
    }
  }

  cleanAndValidateQuery(query: string): string {
    const cleanedQuery = query.replace(/[^a-zA-ZÀ-ÿ\u00f1\u00d10-9\s]/g, '');
    return cleanedQuery;
  }

}
